export default __webpack_public_path__ + "static/media/rechazar.af1f6e47.png";